import {CommonModule} from '@angular/common';
import {Component, EventEmitter, inject, Input, Output, ViewChild} from '@angular/core';
import {DxFormModule} from 'devextreme-angular/ui/form';
import {DxLoadIndicatorModule} from 'devextreme-angular/ui/load-indicator';
import notify from 'devextreme/ui/notify';
import {ValidationRule} from 'devextreme-angular/common';

import {PasswordTextBoxComponent} from 'src/app/components/library/password-text-box/password-text-box.component';
import {FormPopupComponent} from 'src/app/components/utils/form-popup/form-popup.component';
import {ChangePasswordCommand, AuthClient} from '@services';

@Component({
    selector: 'change-profile-password-form',
    templateUrl: './change-profile-password-form.component.html',
    styleUrls: ['./change-profile-password-form.component.scss'],
    imports: [
        CommonModule,
        DxFormModule,
        DxLoadIndicatorModule,
        PasswordTextBoxComponent,
        FormPopupComponent,
    ],
})
export class ChangeProfilePasswordFormComponent {
    @ViewChild(FormPopupComponent, {static: true}) formPopup;
    @ViewChild('confirmField', {static: true}) confirmField: PasswordTextBoxComponent;

    @Input() userId: string;
    @Input() visible = false;
    @Output() visibleChange = new EventEmitter<boolean>();

    private auth = inject(AuthClient);

    isSaveDisabled = true;

    formData: Record<string, any> = {};

    confirmPasswordValidators: ValidationRule[] = [
        {
            type: 'compare',
            message: 'Passwords do not match',
            comparisonTarget: () => this.formData.password,
        },
    ];

    onFieldChanged() {
        const formValues = Object.entries(this.formData);

        this.isSaveDisabled = (
            formValues.length != 2 ||
            !!formValues.find(([_, value]) => !value) ||
            !this.formPopup.isValid());
    }

    saveNewPassword(): void {
        const command = new ChangePasswordCommand({
            userId: this.userId,
            newPassword: this.formData.password,
        });

        this.auth.changePassword(command).subscribe({
            next: () => {
                this.changeVisible(false);
                this.formData = {};
                notify({message: 'Password Changed', position: 'bottom center'}, 'success', 3000);
            },
            error: (errors: Array<any>) => {
                errors.forEach((errMsg => {
                    notify({
                        message: errMsg.message,
                        type: "error",
                        displayTime: 5000,
                    }, {
                        position: "bottom right",
                        direction: "up-push"
                    });
                }));
            }
        });
    }

    checkConfirm(): void {
        this.confirmField.revalidate();
    }

    onNewPasswordChanged() {
        this.checkConfirm();
        this.onFieldChanged();
    }

    changeVisible(visible: boolean): void {
        this.visible = visible;
        this.visibleChange.emit(this.visible);
    }
}
